// extracted by mini-css-extract-plugin
export default {"wirWunderContainer":"u_7YSvWpqHy3jQe4q8k5","projectsWirwunderHeader":"_21FjJl3q5DiMx7OzLEQm","logoWirwunder":"YBt9r947pzLtGB1dxlDE","logoSparkasse":"cI2Odc7DA1RkyrfVEa8Q"};